import type { FC, ReactNode } from "react";
import React from "react";

import type { Identity, User } from "@core/domains/identity";

import { PageContainer } from "@react/web/app";

import { AccountsView } from "../features/accounts/index.ts";
import { UserBalanceSummary } from "../features/billing/index.ts";

export const Accounts: FC = () => {
  const renderAccountBalance = (
    user: User,
    identities: readonly Identity[],
  ): ReactNode => (
    <UserBalanceSummary identities={identities} principalId={user.id} />
  );

  return (
    <PageContainer>
      <AccountsView renderAccountBalance={renderAccountBalance} />
    </PageContainer>
  );
};
